@for (order of orders(); track order.id) {
    <sf-order-card [order]="order"></sf-order-card>
} @empty {
    <sf-empty message="No orders placed"></sf-empty>
}
